export default __webpack_public_path__ + "static/media/hybrid-right.abafe255.jpg";